import logScope from 'log-scope'

const log = logScope('fakeData')

const fakeData = {}

fakeData.headQFirmware = [{
  downloadurl: 'fakeurl/file',
  filename: 'rideQ.zip',
  timstamp: 1555751167234,
  description: 'Fake firmware',
  status: 1,
  profile: 'development',
  version: 255,
  id: '1234132qwef'
}, {
  downloadurl: 'fakeurl/file2',
  filename: 'rideQ.zip',
  timstamp: 1555751167220,
  description: 'Testing testing',
  status: 0,
  profile: '',
  version: 254,
  id: 'sdfgsdfg'
}, {
  downloadurl: 'fakeurl/file3',
  filename: '123',
  timstamp: 1555751167213,
  description: 'Init',
  status: 0,
  profile: '',
  version: 253,
  id: 'asdfasfe'
}]

fakeData.headQ = [{
  'profile': 'development',
  'angles': {
    'mode_1': [ 25, 13, 2 ],
    'mode_2': [ 32, 18, 5 ],
    'mode_3': [ 38, 23, 8 ]
  },
  'configUnits': {
    'buttonDownTimeToChangeMode': 'ms',
    'buttonDownTimeToShutDown': 'ms',
    'buttonDownTimeToStopSession': 'ms',
    'buttonUpTimeSetMode': 'ms',
    'debounce': 'ms',
    'hysteresis': 'percentage of level',
    'idleTimeToShutDown': 'sec',
    'maxAlarmLength': 'ms',
    'minAlarmLength': 'ms',
    'minAlarmResetTime': 'ms',
    'pendingAlarmDelay': 'ms'
  },
  'deviceConfiguration': {
    'buttonDownTimeToChangeMode': 100,
    'buttonDownTimeToShutDown': 1500,
    'buttonDownTimeToStopSession': 1000,
    'buttonUpTimeSetMode': 1000,
    'debounce': 200,
    'idleTimeToShutDown': 60
  },
  'firmwareVersion': 258,
  'latestChange': 1554144356753,
  'levelConfiguration': {
    'hysteresis': 62259,
    'maxAlarmLength': 1000,
    'minAlarmLength': 500,
    'minAlarmResetTime': 200,
    'pendingAlarmDelay': 400,
    'signal': 0
  },
  'meanLevel': 4,
  id: 'lkajhdsfkajhdsfkja'
}, {
  'profile': 'production',
  'angles': {
    'mode_1': [ 25, 13, 2 ],
    'mode_2': [ 32, 18, 5 ],
    'mode_3': [ 38, 23, 8 ]
  },
  'configUnits': {
    'buttonDownTimeToChangeMode': 'ms',
    'buttonDownTimeToShutDown': 'ms',
    'buttonDownTimeToStopSession': 'ms',
    'buttonUpTimeSetMode': 'ms',
    'debounce': 'ms',
    'hysteresis': 'percentage of level',
    'idleTimeToShutDown': 'sec',
    'maxAlarmLength': 'ms',
    'minAlarmLength': 'ms',
    'minAlarmResetTime': 'ms',
    'pendingAlarmDelay': 'ms'
  },
  'deviceConfiguration': {
    'buttonDownTimeToChangeMode': 100,
    'buttonDownTimeToShutDown': 1500,
    'buttonDownTimeToStopSession': 1000,
    'buttonUpTimeSetMode': 1000,
    'debounce': 200,
    'idleTimeToShutDown': 60
  },
  'firmwareVersion': 258,
  'latestChange': 1554144356753,
  'levelConfiguration': {
    'hysteresis': 62259,
    'maxAlarmLength': 1000,
    'minAlarmLength': 500,
    'minAlarmResetTime': 200,
    'pendingAlarmDelay': 400,
    'signal': 0
  },
  'meanLevel': 4,
  id: 'LW1FkBSa8i'
}]

fakeData.subscribers = [{
  id: '-LW1FkBSa8i-V_07RLiy',
  'email': 'mattias@nodemap.se',
  'timestamp': 1547299914397
},
{
  id: '-LW1FkasdSa8i-V_07RLiy',
  'email': 'ridington@rideq.se',
  'timestamp': 1547384834936
},
{
  id: '-LW6QMs5DzZKHZWgBcRi',
  'email': 'elisabeth@carlundhorse.se',
  'timestamp': 1547386584566
}
]

fakeData.init = function (store) {
  const dataSets = ['headQFirmware', 'headQ']

  dataSets.forEach(dataSet => {
    store.commit(dataSet, this[dataSet])
  })

  log.success('Initializing')
}

export default fakeData
